import UnderConstruction from "../components/UnderConstruction.js"
import "../styles.css";
// import InfoCard from "../components/InfoCard.js";

export default function Blog() {
  return (
    <div>
        <UnderConstruction/>
        {/*
        <InfoCard>
        <p>
            <h3>Topics to write about:</h3>
            <h4>Amateur Radio, the original hacker culture</h4>
                <h5>What CSCI concepts have its origins from radio?</h5>
            <h4>Good ideas merit good presentation</h4>
                <h5>Patrick Winston/ Few will care about the technical signifance about a project -- Is it useful?</h5>
            <h4>On the importance of knowing serial communication protocols</h4>
                <h5>CSCI students get very little exposure of this, at least in VIU</h5>
        </p>

        </InfoCard>
        */}
    </div>
  )
}
